<div class="message-container">
	<div class="title">{{ "OFFLINE_WARNING__TITLE" | transloco }}</div>
	<div class="message">{{ "OFFLINE_WARNING__MESSAGE" | transloco }}</div>

	<button *ngIf="showRetry && isV2" type="button" class="try-again" (click)="retry.emit()">
		{{ "OFFLINE_WARNING__TRY_AGAIN" | transloco }}
	</button>

	<ion-button
		*ngIf="showRetry && !isV2"
		class="try-again"
		shape="round"
		(click)="retry.emit()"
	>
		{{ "OFFLINE_WARNING__TRY_AGAIN" | transloco }}
	</ion-button>
</div>
